import { Text } from '@chakra-ui/layout';
import { Box, Button, Container, Flex } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';
import SpeakerConferenceImage from '@/assets/images/presentation/speaker-conference.png';

import { RedCardWithDownloadButton } from '@/components/ui/shared/cards/RedCardWithDownloadButton/RedCardWithDownloadButton';

export const UnforgettableConference = () => {
  const { t } = useTranslation();

  return (
    <Container maxW="1100px" textAlign="center">
      <Text mt={12} mb={6} fontSize="3xl" fontFamily="heading" fontWeight="bold">
        {t('newEventPage.yourPursuit')}
      </Text>
      <Text>{t('newEventPage.yourPursuitDescription')}</Text>
      <Text fontWeight="semibold" mt={4} mb={6}>
        {t('newEventPage.ourMission')}
      </Text>
      <Button
        as={Link}
        href="/contact-us/conferences"
        variant="solid"
        colorScheme="black"
        alignSelf="flex-start"
        mt={6}
        rightIcon={<ArrowIcon />}
      >
        {t('newEventPage.getStarted')}
      </Button>
      <Flex flexDirection={{ base: 'column', lg: 'row' }} mt={16} gap={4}>
        <Box flex={1}>
          <Image src={SpeakerConferenceImage} alt="Power of partnership" />
        </Box>
        <Flex flex="1" alignItems="flex-start" justifyContent="center" flexDirection="column">
          <Text textAlign="left" fontFamily="heading" fontWeight="bold" fontSize="3xl">
            {t('newEventPage.powerOfPartnershipPartOne')}{' '}
            <Text fontFamily="heading" as="span" color="violet.500">
              {t('newEventPage.powerOfPartnershipPartTwo')}
            </Text>
          </Text>
          <Text textAlign="left" mt={6}>
            {t('newEventPage.powerOfPartnershipDescriptionPartOne')}
          </Text>
          <Text textAlign="left" mt={4}>
            {t('newEventPage.powerOfPartnershipDescriptionPartTwo')}
          </Text>
        </Flex>
      </Flex>
      <RedCardWithDownloadButton
        slug="twelve-pitfalls"
        smallHeading={t('newEventPage.downloadCardOne.smallTitle')}
        heading={t('newEventPage.downloadCardOne.title')}
      />
    </Container>
  );
};
